import imageOne from '@/assets/images/cities/regina1.jpg'
import imageTwo from '@/assets/images/cities/regina2.jpg'
import imageThree from '@/assets/images/cities/regina3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Regina',
  writeup: '',
  website: 'ReginaNotaryPublic.com',
  url: 'https://www.reginanotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(306) 993-0808',
      hours: {
        monday: '9:30AM to 11:00AM and 1:30PM to 4:00PM',
        tuesday: '9:30AM to 11:00AM and 1:30PM to 4:00PM',
        wednesday: '9:30AM to 11:00AM and 1:30PM to 4:00PM',
        thursday: '9:30AM to 11:00AM and 1:30PM to 4:00PM',
        friday: '9:30AM to 11:00AM and 1:30PM to 4:00PM',
        saturday: '',
        sunday: ''
      },
      address: '15th Avenue Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/saskatchewan/cities/regina.js